<script>
  import { onMount } from 'svelte'

  let numberOfSnowflakes
  let width
  let height
  let canvas
  let context
  let active
  let snowflake
  let snowflakes = []

  class Snowflake {
    constructor() {
      this.x = 0
      this.y = 0
      this.vy = 0
      this.vx = 0
      this.r = 0
      this.o = 0

      this.reset(true)
    }
    reset(isFirstRun = false) {
      this.x = Math.random() * width
      if (isFirstRun) {
        console.log(height)
        this.y = Math.random() * height
      } else {
        this.y = 0
      }
      this.vy = 1 + Math.random() * 0.5
      this.vx = 0.5 - Math.random()
      this.r = 1 + Math.random() * 2
      this.o = 0.5 + Math.random() * 0.5
    }
  }

  function getSizes() {
    return {
      // height: 5387, // TODO: This should be dynamic
      height:
        document.body.scrollHeight > window.innerHeight
          ? document.body.scrollHeight
          : window.innerHeight,
      width: document.body.clientWidth,
    }
  }

  onMount(() => {
    setTimeout(() => {
      const sizes = getSizes()
      width = sizes.width
      height = sizes.height
      numberOfSnowflakes = height / 15

      context = canvas.getContext('2d')
      for (let i = 0; i < numberOfSnowflakes; i++) {
        snowflake = new Snowflake()
        snowflakes.push(snowflake)
      }
      handleResize()
    }, 250)
  })

  function handleResize() {
    const sizes = getSizes()
    width = sizes.width
    height = sizes.height

    canvas.width = width
    canvas.height = height

    const wasActive = active
    active = width > 100

    if (!wasActive && active) {
      if (window) {
        window.requestAnimationFrame(update)
      }
    }
  }

  function update() {
    const sizes = getSizes()
    width = sizes.width
    height = sizes.height
    context.clearRect(0, 0, width, height)

    if (!active) return

    for (let i = 0; i < numberOfSnowflakes; i++) {
      snowflake = snowflakes[i]
      snowflake.y += snowflake.vy
      snowflake.x += snowflake.vx

      context.fillStyle = '#fff'
      context.globalAlpha = snowflake.o
      context.beginPath()
      context.arc(snowflake.x, snowflake.y, snowflake.r, 0, Math.PI * 2, false)
      context.closePath()
      context.fill()

      if (snowflake.y > height) {
        snowflake.reset()
      }
    }

    window.requestAnimationFrame(update)
  }
</script>

<svelte:window on:resize={handleResize} />

<canvas {width} {height} bind:this={canvas} />

<style>
  canvas {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
  }
</style>
